export default __webpack_public_path__ + "static/media/Features-graphic.ce43a765.png";